import React, { useState } from "react";
import { BsGear } from "react-icons/bs";
import { TbGalaxy } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import AISettingsModal from "./AI/SettingsModal.js/AISettingsModal";
import PublishModal from "./PublishModal";
import { MdApi, MdOutlineWeb } from "react-icons/md";

const NavbarCodespace = ({ projectName, chatId, fetchActions, context }) => {
    const { project_id } = useParams();
    const navigate = useNavigate();
    const user_id = sessionStorage.getItem("user_id");
    const [copied, setCopied] = useState(false);
    const [openAiSettingdModal, setOpenAiSettingdModal] = useState(false);
    const [openPublishModal, setOpenPublishModal] = useState(false);


    const copyToClipboard = () => {
        const message = project_id;

        navigator.clipboard.writeText(message).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        });
    };



    return (
        <div className="main_codespaces_cont_navbar">
            <div className="control_nav_cont">
                <p className="sidebar_logo"><i><TbGalaxy /></i></p>
                <div className="project_header">
                    <span onClick={() => navigate(`/project_panel/${project_id}/databases`)}  className="fade-in">{projectName}</span>
                    <span onClick={copyToClipboard} className="project_id_header">{copied ? <i className="fa-solid fa-check fade-in"></i> : <span className="fade-in">{project_id}</span>}</span>
                    {/* <span className="demo_version_header">Demo V1.1</span> */}
                </div>

            </div>
            {/* <div className="control_nav_cont">
                <div className="action_nav_codebase">
                    <div onClick={() => setOpenView("code")} className={`action_nav_codebase_btn ${view == "code" ? "selected_action_nav_codebase_btn" : ""}`}><TbCode /></div>
                    <div onClick={() => setOpenView("preview")} className={`action_nav_codebase_btn ${view == "preview" ? "selected_action_nav_codebase_btn" : ""}`}><MdOutlinePreview /></div>
                </div>
            </div> */}
            <div className="control_nav_cont">
                <button className="publish_btn" onClick={() => setOpenPublishModal(true)}>
                    {context == "webapp" ? (
                        <>Publish <MdOutlineWeb /></>
                    ) : context == "api" ? (
                        <>Publish API <MdApi /></>
                    ) : (
                        <>Publish</>
                    )}
                </button>

                <p className="settings_link" onClick={() => setOpenAiSettingdModal(true)}><i><BsGear /></i></p>

                {/* <Dropdown>
                    <Dropdown.Toggle className="bell">
                        <TbBrandGithub />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="custom-dropdown-menu-settings">
                        <div className="settings_center_codespace">
                            <p className="connect_title">Connect your GitHub account</p>
                            <p className="connect_description">
                                Link your GitHub to enable seamless integration and collaboration.
                            </p>
                            <button className="connect_to_git_btn">Connect <TbBrandGithub/></button>

                        </div>
                    </Dropdown.Menu>
                </Dropdown> */}

                {/* <Dropdown>
                    <Dropdown.Toggle className="bell">
                        <TbPlug />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="custom-dropdown-codespace-settings">
                        <div className="settings_center_codespace_plugs">
                            <p className="connect_title">Connectors</p>
                            <p className="connect_description">
                                Connect to you favourite services and integrate them in your code.
                            </p>
                            <div className="resource_codespace_dropdown">
                                <div className="resource_codespace_dropdown_card">
                                    <p className="resource_codespace_dropdown_card_title">Stripe</p>
                                    <i><BsStripe/></i>
                                </div>
                            </div>

                        </div>
                    </Dropdown.Menu>
                </Dropdown> */}

            </div>
            <AISettingsModal
                show={openAiSettingdModal}
                handleClose={() => setOpenAiSettingdModal(false)}
                context={context}
            />
            <PublishModal
                show={openPublishModal}
                handleClose={() => setOpenPublishModal(false)}
                chatId={chatId}
                fetchActions={fetchActions}
                context={context}
            />
        </div>
    )
}

export default NavbarCodespace